import React from "react";
import { VERSION, EXT_TITLE } from "../../../../config/consts";
import * as Styled from "./styled";

export default () => (
  <Styled.HeaderLogo>
    <Styled.NavbarBrand to="/">{EXT_TITLE} {VERSION}</Styled.NavbarBrand>
  </Styled.HeaderLogo>
);
